(function (argument) {
	'use strict';

	angular.module('changdobels')
		.component('cdLodgingDates', {
			templateUrl: ['TEMPLATE_URL', function getTemplateUrl(TEMPLATE_URL) {
				return TEMPLATE_URL + '/templates/lodging-dates.html';
			}],
			require: {
				formCtrl: '^^form'
			},
			controller: LodgingDatesController
		});

	LodgingDatesController.$inject = [
		'$scope',
		'$http',
		'$q',
		'AJAX_URL'
	];

	function LodgingDatesController( $scope, $http, $q, AJAX_URL ) {
		var $ctrl = this;
		var cancelRequest = null;

		var defaultMinFromDate = null;
		var defaultMinToDate = null;

		var defaultMaxDate = null;

		var dateFormat = 'YYYY-MM-DD';

		$ctrl.ready = false;

		$ctrl.fromDate = '';
		$ctrl.toDate = '';

		$ctrl.minFromDate = null;
		$ctrl.minToDate = null;

		$ctrl.maxFromDate = null;
		$ctrl.maxToDate = null;

		$ctrl.maxDate = null;
		$ctrl.onCheckinSelect = onCheckinSelect;
		$ctrl.onCheckoutSelect = onCheckoutSelect;
		$ctrl.onRenderDay = onRenderDay;
		$ctrl.luxury = '0';
		$ctrl.dogs = [];
		$ctrl.validatorsInitialized = false;

		$ctrl.$onInit = $onInit;
		$ctrl.$postLink = $postLink;
		$ctrl.$onDestroy = $onDestroy;

		function $onInit() {
			$ctrl.minFromDate = defaultMinFromDate =
				moment().add( 1, 'd' ).format(dateFormat);

			$ctrl.minToDate = defaultMinToDate =
				moment($ctrl.minFromDate).add( 1, 'd' ).format(dateFormat);

			$ctrl.maxFromDate = $ctrl.maxToDate = defaultMaxDate =
				moment($ctrl.minFromDate).add( 1, 'Y' ).format(dateFormat);

			// TODO: replace chosen jquery plugin with angular component and
			// remove the following
			var dogsSelect = jQuery('select.js-dogs-lodging');
			$ctrl.dogs = dogsSelect.val() || [];

			dogsSelect.change( function () {
				$scope.$apply( function () {
					$ctrl.dogs = dogsSelect.val();
					$ctrl.ready = false;

					if (cancelRequest) {
						cancelRequest.resolve();
					}

					getDateAvalability();
				} );
			} );
		}

		function $postLink() {
			// Not sure this is needed but why not
			if ($ctrl.dogs.length > 0) {
				getDateAvalability();
			}
		}

		function getDateAvalability() {
			cancelRequest = $q.defer();

			$http.get( AJAX_URL, {
				params: {
					'action'     : 'changdobels_get_date_avalability',
					'start-date' : defaultMinFromDate,
					'end-date'   : defaultMaxDate,
					'dogs[]'     : $ctrl.dogs
				},
				timeout: cancelRequest.promise
			}).then(function successCallback( response ) {
				$ctrl.ready = true;
				$ctrl.days  = response.data;

				if (!$ctrl.validatorsInitialized) {
					$scope.$applyAsync( setupValidators );
				}

				$ctrl.formCtrl.checkout.$validate();
				angular.element( '#booking-form' ).trigger( 'change' );
			}).catch(function errorCallback( response ) {
				console.error( response );
			});
		}

		function $onDestroy() {
			if ( cancelRequest ) {
				cancelRequest.resolve();
			}
		}

		function onCheckoutSelect( date ) {
			if ( date ) {
				var momentDate = moment( date, dateFormat );

				if ( momentDate.isValid() ) {
					$ctrl.toDate = date;

					$scope.$applyAsync(function () {
						$ctrl.formCtrl.checkin.$validate();
						angular.element( '#booking-form' ).trigger( 'change' );
					});
				}
			}
		}

		function onCheckinSelect( date ) {
			if ( date ) {
				var momentDate = moment( date, dateFormat );

				if ( momentDate.isValid() ) {
					var dateData = getDayData( date );
					var minToDate = momentDate.add( 1, 'd' );
					var toDateData = getDayData( minToDate );

					if (dateData.type === 'hogsasong' || dateData.type === 'hogtid' ||
						toDateData.type === 'hogsasong' || toDateData.type === 'hogtid' ) {
						minToDate.add( 1, 'd' );
					}

					var maxToDate = moment( minToDate );

					while (dateData && dateData.slots >= $ctrl.dogs.length ) {
						maxToDate.add( 1, 'd' );
						dateData = getDayData( maxToDate );
					}

					$ctrl.minToDate = minToDate.format( dateFormat );
					$ctrl.maxToDate = maxToDate.format( dateFormat );

					$ctrl.fromDate = date;

					$scope.$applyAsync(function () {
						$ctrl.formCtrl.checkout.$validate();
						angular.element( '#booking-form' ).trigger( 'change' );
					});

					return;
				}
			}

			$ctrl.minToDate = defaultMinToDate;
		}

		function onRenderDay( date, dayOptions ) {
			var momentDate = moment( date );
			var dateData = getDayData( momentDate );

			if ( dateData ) {
				if ( $ctrl.dogs.length > dateData.slots ) {
					dayOptions[0] = false;
					dayOptions[1] += ' cd-datepicker__day--full';
					dayOptions[2] ='Fullbokad dag';
				} else if ( $ctrl.fromDate && $ctrl.toDate &&
					momentDate >= moment( $ctrl.fromDate, dateFormat ) &&
					momentDate <= moment( $ctrl.toDate, dateFormat ) ) {
					dayOptions[1] += ' cd-datepicker__day--booked';
					dayOptions[2] ='Bokad dag';
				} else {
					dayOptions[1] += ' cd-datepicker__day--' + dateData.type;

					switch ( dateData.type ) {
						case 'helg': {
							dayOptions[2] ='Helg';
							break;
						} case 'hogsasong': {
							dayOptions[2] ='Högsäsong';
							break;
						} case 'hogtid': {
							dayOptions[2] ='Högtid';
							break;
						}
					}
				}
			}

			return dayOptions;
		}

		function setupValidators() {
			$ctrl.formCtrl.checkout.$validators.leastThreeDays = function (toDate) {
				if ($ctrl.fromDate && $ctrl.toDate) {
					var fromDate = moment( $ctrl.fromDate, dateFormat );
					var toDate = moment( toDate, dateFormat );

					var toDateData = getDayData(toDate);
					var fromDateData = getDayData(fromDate);

					if (fromDateData && toDateData && toDate.diff( fromDate, 'd' ) < 2 ) {
						// With less than two days between, neither can be high seasons
						return (fromDateData.type === 'helg' || fromDateData.type === 'ordinarie') &&
							(toDateData.type === 'helg' || toDateData.type === 'ordinarie');
					}
				}

				return true;
			};

			$ctrl.formCtrl.checkout.$validators.christmas =
			$ctrl.formCtrl.checkin.$validators.christmas = function (toDate) {
				return !/\-12\-(24|31)$/.test(toDate);
			};

			$ctrl.formCtrl.checkout.$validators.fullbookedDays = function (toDate) {
				if ($ctrl.fromDate && toDate) {
					var fromDate = moment( $ctrl.fromDate, dateFormat );
					var toDate = moment( toDate, dateFormat );

					if ( fromDate < toDate ) {
						while ( fromDate <= toDate ) {
							var fromDateData = getDayData( fromDate );

							if ( $ctrl.dogs.length > fromDateData.slots ) {
								return false;
							}

							fromDate.add(1, 'd');
						}
					}
				}

				return true;
			};

			$ctrl.validatorsInitialized = true;
		}

		function getDayData(date) {
			if (!$ctrl.days) {
				return {};
			}

			if (date instanceof moment) {
				date = date.format( dateFormat );
			}

			return $ctrl.days[date] || {};
		}
	}
})();